<script setup>
import { RouterLink } from 'vue-router'
import { ShieldCheckIcon } from '@heroicons/vue/24/outline'

// Links a páginas de detalle de cada servicio
const serviceLinks = [
  { label: 'Derecho al olvido', href: '/services/derecho-olvido' },
  { label: 'Derecho al olvido post-mortem', href: '/services/derecho-olvido-postmortem' },
  { label: 'Testamento digital', href: '/services/testamento-digital' }
]

const resourceLinks = [
  { label: 'Cómo funciona', href: '/como-funciona' },
  { label: 'Quiénes somos', href: '/quienes-somos' },
  { label: 'FAQ', href: '/centro-ayuda' },
  { label: 'Guía GDPR', href: '/legal/rgpd-info' }
]

const legalLinks = [
  { label: 'Términos y condiciones', href: '/terminos-condiciones' },
  { label: 'Política de privacidad', href: '/politica-privacidad' },
  { label: 'Política de cookies', href: '/politica-cookies' }
]

</script>

<template>
  <footer class="bg-slate-950 text-white py-16">
    <div class="max-w-6xl mx-auto px-6">
      <div class="grid md:grid-cols-12 gap-12 mb-12">
        <!-- Brand -->
        <div class="md:col-span-5">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-10 h-10 bg-gradient-to-br from-accent-400 to-accent-500 rounded-xl flex items-center justify-center">
              <ShieldCheckIcon class="w-6 h-6 text-white" />
            </div>
            <span class="font-bold text-2xl">Olvidadme</span>
          </div>
          <p class="text-slate-400 text-sm leading-relaxed max-w-sm">
            Plataforma legal-tech para el ejercicio del derecho al olvido y gestión de privacidad digital conforme al RGPD.
          </p>
        </div>

        <!-- Servicios -->
        <div class="md:col-span-2">
          <h4 class="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-500">Servicios</h4>
          <ul class="space-y-3 text-sm text-slate-400">
            <li v-for="link in serviceLinks" :key="link.label">
              <RouterLink
                :to="link.href"
                class="hover:text-white transition-colors"
              >
                {{ link.label }}
              </RouterLink>
            </li>
          </ul>
        </div>

        <!-- Recursos -->
        <div class="md:col-span-2">
          <h4 class="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-500">Recursos</h4>
          <ul class="space-y-3 text-sm text-slate-400">
            <li v-for="link in resourceLinks" :key="link.label">
              <RouterLink
                :to="link.href"
                class="hover:text-white transition-colors"
              >
                {{ link.label }}
              </RouterLink>
            </li>
          </ul>
        </div>

        <!-- Legal -->
        <div class="md:col-span-3">
          <h4 class="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-500">Legal</h4>
          <ul class="space-y-3 text-sm text-slate-400">
            <li v-for="link in legalLinks" :key="link.label">
              <RouterLink
                :to="link.href"
                class="hover:text-white transition-colors"
              >
                {{ link.label }}
              </RouterLink>
            </li>
          </ul>
        </div>
      </div>

      <!-- Footer Bottom - Disclaimer -->
      <div class="pt-8 border-t border-slate-800">
        <p class="text-xs text-slate-500 leading-relaxed">
          &copy; {{ new Date().getFullYear() }} Olvidadme. Servicio de gestión de derechos ARCO conforme a Reglamento (UE) 2016/679 y Ley Orgánica 3/2018 de Protección de Datos. Los resultados dependen del cumplimiento de requisitos legales específicos del Artículo 17 RGPD. Los plazos de tramitación dependen de las plataformas destinatarias.
        </p>
      </div>
    </div>
  </footer>
</template>
